import React from 'react';

interface FlowArrowProps {
  direction?: 'right' | 'down' | 'left' | 'up';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const FlowArrow: React.FC<FlowArrowProps> = ({
  direction = 'right',
  size = 'md',
  className = '',
}) => {
  const sizes = {
    sm: { lineWidth: 32, lineHeight: 2, chevronSize: 8 },
    md: { lineWidth: 48, lineHeight: 2, chevronSize: 10 },
    lg: { lineWidth: 64, lineHeight: 3, chevronSize: 12 },
  };

  const { lineWidth, lineHeight, chevronSize } = sizes[size];

  const rotations = {
    right: 'rotate-0',
    down: 'rotate-90',
    left: 'rotate-180',
    up: '-rotate-90',
  };

  return (
    <div className={`inline-flex items-center ${rotations[direction]} ${className}`}>
      {/* Gradient line */}
      <div
        className="bg-gradient-to-r from-[#3b82f6]/30 via-[#3b82f6] to-[#06b6d4] rounded-full"
        style={{ width: lineWidth, height: lineHeight }}
      />
      {/* Chevron arrow head */}
      <div
        className="border-t-2 border-r-2 border-[#06b6d4] -ml-1"
        style={{
          width: chevronSize,
          height: chevronSize,
          transform: 'rotate(45deg)',
        }}
      />
    </div>
  );
};

// Simpler connector dot with pulse for step indicators
export const StepConnector: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`flex flex-col items-center gap-1 ${className}`}>
    <div className="w-2 h-2 rounded-full bg-[#3b82f6]" />
    <div className="w-0.5 h-8 bg-gradient-to-b from-[#3b82f6] to-[#06b6d4] opacity-60" />
    <div className="w-2 h-2 rounded-full bg-[#06b6d4]" />
  </div>
);

export default FlowArrow;
